module.exports = __webpack_public_path__ + "img/zfdzpt_charact_5.85faae50.svg";